import React from 'react'
import '../Itemcard/style.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Banner1 from '../Images/banner1.jpg'
import Banner2 from '../Images/banner2.jpg'
import Banner3 from '../Images/banner3.jpg'
import Banner4 from '../Images/banner4.jpg'

export const Carousel = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    return (
        <div>
            <div className="bannerhome">
            <Slider {...settings}>
                <div>
                    <img src={Banner4} alt="" />
                </div>
                <div>
                    <img src={Banner3} alt="" />
                </div>
                <div>
                    <img src={Banner2} alt="" />
                </div>
                <div>
                    <img src={Banner1} alt="" />
                </div>
            </Slider>
            </div>
        </div>
    )
}
